import React, { useEffect, useState } from "react"
import toast from "react-hot-toast"
import { Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap"

function RaiseQueryFrom({ id, open, setOpen, steps, onSubmit, onClose }) {
  const [selectedStep, setSelectedStep] = useState("")
  const [message, setMessage] = useState(null)

  const handleSubmit = async () => {
    if (!selectedStep) {
      toast.error(
        "Please select the step for which you are raising the query.",
        {
          id: "toastMessage",
        }
      )
      return
    }
    if (!message) {
      toast.error("Please enter the reason for raising this query.", {
        id: "toastMessage",
      })
      return
    }
    const item = steps.find((item) => item.key === selectedStep)
    onSubmit({ key: item.key, label: item.label, message })
  }

  useEffect(() => {
    setSelectedStep("")
    setMessage(null)
  }, [steps])

  return (
    <>
      <Modal
        isOpen={open}
        toggle={() => {
          setOpen((prev) => !prev)
        }}
        returnFocusAfterClose={true}
        centered
        className="custom-size"
      >
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          Add query
          <p style={{ fontSize: "14px", fontWeight: "400", marginBottom: 0 }}>
            Please select and describe the reason for raising the query.
          </p>
        </ModalHeader>
        <ModalBody>
          <div className="px-3">
            <Label className="col-form-label pt-0">
              Select KYC Step<span className="error">*</span>
            </Label>
            <select
              className={`form-select pageSize cp`}
              onChange={(e) => setSelectedStep(e.target.value)}
              value={selectedStep}
            >
              <option value={""}>Select Step</option>
              {steps.map((item, index) => (
                <option key={`steps_${index}`} value={item.key}>
                  {item.label}
                </option>
              ))}
            </select>

            <Label className="col-form-label">
              Query Reason<span className="error">*</span>
            </Label>
            <Input
              name="comments"
              type="textarea"
              className="form-control textarea"
              id="horizontal-firstname-Input"
              placeholder="Add Query raise reason here"
              onChange={(e) => setMessage(e.target.value)}
              value={message}
            />
          </div>
          <div className="mt-3 pt-3 mb-0 button-wrapper buttons position-relative z-2">
            <button onClick={() => onClose()} type="button" className="cancel">
              Cancel
            </button>
            <button
              type="button"
              className="approve btn btn-secondary"
              onClick={handleSubmit}
            >
              Add Query
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default RaiseQueryFrom
